<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <div class="content">
            <!-- <div
                *ngIf="showSuccessChange"
                style="
                    background-color: greenyellow;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
                i18n="PO delivery updated successfully - message"
            >
                {{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.SHOW_MESSAGES.PO_INVENTORY_UPDATE"
                        | translate
                }}
            </div>

            <div
                *ngIf="showErrorChange"
                style="
                    background-color: red;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
                i18n="PO delivery updated successfully - message"
            >
                {{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.SHOW_MESSAGES.PO_INVENTORY_ERROR"
                        | translate
                }}
            </div>
            <div
                *ngIf="closPoSuccessMessage"
                style="
                    background-color: greenyellow;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
                i18n="PO delivery updated successfully - message"
            >
                {{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.SHOW_MESSAGES.PO_INVENTORY_SUCCESS"
                        | translate
                }}
            </div>-->
            <div style="float: right">
                <button class="back-button" (click)="backToPo()">
                    {{
                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.BUTTONS.BACK_TO_PO"
                            | translate
                    }}
                </button>
            </div>
            <div *ngIf="poDetails != null">
                <div>
                    <table class="poDetails">
                        <tr>
                            <th>
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.PO_NUMBER"
                                        | translate
                                }}:
                            </th>
                            <td>-</td>
                            <td>&nbsp;{{ poDetails.poNumber }}</td>
                        </tr>
                        <tr>
                            <th>
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.SUPPLIER"
                                        | translate
                                }}:
                            </th>
                            <td>-</td>
                            <td>&nbsp;{{ poDetails.supplierName }}</td>
                        </tr>
                        <tr>
                            <th>
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.MANUFACTURER"
                                        | translate
                                }}:
                            </th>
                            <td>-</td>
                            <td>&nbsp;{{ poDetails.manufacturerName }}</td>
                        </tr>
                        <tr>
                            <th>
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.PO_DATE"
                                        | translate
                                }}:
                            </th>
                            <td>-</td>
                            <td>
                                &nbsp;{{
                                    poDetails.poDate | date: "mediumDate"
                                }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.APPROVED_BY"
                                        | translate
                                }}:
                            </th>
                            <td>-</td>
                            <td>&nbsp;{{ poDetails.approvedBy }}</td>
                        </tr>
                    </table>
                </div>

                <button
                    style="float: right"
                    class="btn btn-default"
                    (click)="openConfirmClosePODialog(poDetails)"
                >
                    {{
                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.BUTTONS.CLOSE_ORDER"
                            | translate
                    }}
                </button>
            </div>
            <br />
            <br />

            <div class="m-8">
                <mat-tab-group
                    (selectedTabChange)="onDeliveryTabChanged($event)"
                >
                    <mat-tab
                        label="{{
                            'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.LABEL_TAB_1'
                                | translate
                        }}"
                    >
                        <table
                            mat-table
                            [dataSource]="poItems"
                            class="table table-striped tablefixed"
                            #table
                        >
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.NAME"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.formulaName }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="quantity">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.REQUESTED_QUANTITY"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.quantity }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="receivedQuantity">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.RECEIVED_QUANTITY"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.receivedQuantity }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="unit">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.UNIT"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element.unit == pOUnitEnum.KG"
                                        >{{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        *ngIf="element.unit == pOUnitEnum.TONNE"
                                        >{{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                                                | translate
                                        }}
                                    </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.DELIVERY"
                                            | translate
                                    }}
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                    class="action-link"
                                >
                                    <!-- <a *ngIf="element.status==OrderStatusEnum.NEW" (click)="addRowData(po,element)">Add</a> -->
                                    <button
                                        *ngIf="
                                            element.status ==
                                                OrderStatusEnum.NEW ||
                                            element.status ==
                                                OrderStatusEnum.PARTIALLY_COMPLETED
                                        "
                                        class="btn btn-default"
                                        (click)="
                                            AddDeliveryDialog(
                                                poDetails,
                                                element
                                            )
                                        "
                                    >
                                        {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.BUTTONS.DELIVERY"
                                                | translate
                                        }}
                                    </button>
                                    <span
                                        *ngIf="
                                            element.status ==
                                            OrderStatusEnum.COMPLETED
                                        "
                                        >-</span
                                    >
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.STATUS"
                                            | translate
                                    }}
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                    class="action-link"
                                >
                                    <span
                                        *ngIf="
                                            element.status ==
                                            OrderStatusEnum.NEW
                                        "
                                    >
                                        {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.ITEM_STATUS.NEW"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        *ngIf="
                                            element.status ==
                                            OrderStatusEnum.COMPLETED
                                        "
                                    >
                                        {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.ITEM_STATUS.COMPLETED"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        *ngIf="
                                            element.status ==
                                            OrderStatusEnum.PARTIALLY_COMPLETED
                                        "
                                    >
                                        {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.ITEM_STATUS.PARTIALLY_COMPLETED"
                                                | translate
                                        }}
                                    </span>
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns"
                            ></tr>
                        </table>

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </mat-tab>

                    <!-- New Add To Inventory -->

                    <mat-tab
                        label="{{
                            'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.LABEL_TAB_2'
                                | translate
                        }}"
                    >
                        <table
                            mat-table
                            [dataSource]="deliveries"
                            class="table table-striped"
                            #table
                        >
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.NAME"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.formulaName }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="receivedQuantity">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.RECEIVED_QUANTITY"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.receivedQuantity }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="batchNumber">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.BATCH_LOT_NUMBER"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.batchNumber }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.DATE"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdOn | date: "mediumDate" }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="unit">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{
                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.TABLE_HEADERS.UNIT"
                                            | translate
                                    }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element.unit == pOUnitEnum.KG"
                                        >{{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        *ngIf="element.unit == pOUnitEnum.TONNE"
                                        >{{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                                                | translate
                                        }}
                                    </span>
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedAddToInvColumns"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="
                                    let row;
                                    columns: displayedAddToInvColumns
                                "
                            ></tr>
                        </table>
                        <div class="m-8" style="text-align: right">
                            <button
                                class="btn btn-default"
                                [disabled]="deliveries.length == 0"
                                (click)="
                                    addItemToInventoryDialog(
                                        poDetails,
                                        deliveries
                                    )
                                "
                            >
                                {{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.BUTTONS.ADD_TO_INVENTORY"
                                        | translate
                                }}
                            </button>
                            &nbsp; &nbsp;
                        </div>
                        <br />
                        <br />
                    </mat-tab>
                </mat-tab-group>
                <ngx-loading [show]="isLoading"></ngx-loading>
            </div>
        </div>
    </div>
</div>
